import React, { useState, useEffect } from "react";
import i18n from "i18next";
import { fetchWrapper } from "../../helpers/fetchwrapper";

import { baseUrl } from "../../helpers/constants";
import { IZwischenelement } from "../../Models/IZwischenelement";
import { IAdapter } from "../../Models/IAdapter";
import useWindowSize from "../../helpers/useWindowSize";
import {
  ImageSwatch,
  Label,
  SwatchPicker,
  Checkbox,
} from "@fluentui/react-components";
import { ILuebOption } from "../../Models/ILuebOption";

interface ILsp3ConnectProps {
  configurationParameter: any;
  onSelectionChanged: any;
}

function Lsp3Connect(props: ILsp3ConnectProps) {
  const windowSize = useWindowSize();
  const imageSize = windowSize.width > 500 ? 230 : 100;

  const [selectedZubehoerKey, setSelectedZubehoerKey] = useState("");
  const [reactionBar, setReactionBar] = useState(false);

  const [selectedZwischenelement, setSelectedZwischenelement] =
    useState<IZwischenelement>();
  const [selectedAdapter, setSelectedAdapter] = useState<IAdapter>();

  const options: ILuebOption[] = [
    {
      data: {
        imageSrc: `${baseUrl}/IMAGES/ZUBEHOER/INDEXING_250X250.PNG`,
        imageAlt: "L.SP3 connect index",
        selectedImageSrc: `${baseUrl}/IMAGES/ZUBEHOER/INDEXING_250X250.PNG`,
        imageSize: { width: imageSize, height: imageSize },
        unselectable: "on",
      },
      key: "connectIndex",

      text: "L.SP3 connect index",
    },
    {
      data: {
        imageSrc: `${baseUrl}/IMAGES/ZUBEHOER/MONTAGEFLANSCH_250X250.PNG`,
        imageAlt: "L.SP3 connect flange",
        selectedImageSrc: `${baseUrl}/IMAGES/ZUBEHOER/MONTAGEFLANSCH_250X250.PNG`,
        imageSize: { width: imageSize, height: imageSize },
        unselectable: "on",
      },
      key: "connectFlange",
      text: "L.SP3 connect flange",
    },
  ];

  const reactionBarOption: ILuebOption[] = [
    {
      data: {
        imageSrc: `${baseUrl}/IMAGES/ZUBEHOER/REAKTIONSARM_250X250.PNG`,
        imageAlt: "Torque reaction bar",
        selectedImageSrc: `${baseUrl}/IMAGES/ZUBEHOER/REAKTIONSARM_250X250.PNG`,
        imageSize: { width: imageSize, height: imageSize },
        unselectable: "on",
      },
      key: "reactionBar",
      text: "Torque reaction bar",
    },
  ];

  useEffect(() => {
    if (selectedZubehoerKey == "connectFlange") {
      getConnectFlange();
    } else if (selectedZubehoerKey == "connectIndex") {
      getConnectIndex();
    }
  }, [selectedZubehoerKey]);

  const getConnectFlange = () => {
    let typ = "";
    if (props.configurationParameter.rueckstellung == "mechanisch") {
      typ = "Montageflansch Rücks_mechanisch";
    } else if (props.configurationParameter.rueckstellung == "sensorisch") {
      typ = "Montageflansch";
    }

    if (
      typ != "" &&
      props.configurationParameter?.lsp3Selection?.items?.selectedLsp3Article
        ?.baukasten != ""
    ) {
      fetchWrapper
        .getWithAuth(
          `${baseUrl}/api/Configurator/GetZwischenelement?typ=${typ}&baukasten=${props.configurationParameter?.lsp3Selection?.items?.selectedLsp3Article?.baukasten}`,
        )
        .then((result: IZwischenelement | undefined) => {
          // Flange einbinden
          setSelectedAdapter(undefined);
          setSelectedZwischenelement(result);
        });
    }
  };

  const getConnectIndex = () => {
    // KAN vom Antriebsset ermitteln
    const baukasten =
      props.configurationParameter?.lsp3Selection?.items?.selectedLsp3Article
        ?.baukasten;
    if (baukasten) {
      fetchWrapper
        .getWithAuth(
          `${baseUrl}/api/Configurator/GetIndexingAdapter?baukasten=${baukasten}`,
        )
        .then((result: IAdapter | undefined) => {
          // Indexing einbinden
          setSelectedAdapter(result);
          setSelectedZwischenelement(undefined);
        });
    }
  };

  useEffect(() => {
    props.onSelectionChanged({
      selectedAdapter: selectedAdapter,
      selectedZwischenelement: selectedZwischenelement,
      reactionBar: reactionBar,
      selectedZubehoerKey: selectedZubehoerKey,
    });
  }, [reactionBar, selectedAdapter, selectedZwischenelement]);

  return (
    <>
      <div className="lueb-Headline">
        <SwatchPicker
          selectedValue={selectedZubehoerKey}
          onSelectionChange={(ev, val) => {
            if (val.selectedValue != selectedZubehoerKey) {
              setSelectedZubehoerKey(val.selectedValue);
            } else {
              setSelectedZubehoerKey("");
            }
          }}
        >
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {options.map((item) => {
              return (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "2px",
                  }}
                >
                  <ImageSwatch
                    style={{
                      width: 230,
                      height: 230,
                    }}
                    value={typeof item.key == "string" ? item.key : ""}
                    src={item.data.imageSrc ? item.data.imageSrc : ""}
                    aria-label={item.data.imageAlt}
                  />
                  <Label style={{ marginTop: "5px" }} weight="semibold">
                    {item.text}
                  </Label>
                </div>
              );
            })}
          </div>
        </SwatchPicker>
        <SwatchPicker
          selectedValue={reactionBar ? "reactionBar" : ""}
          onSelectionChange={(ev, val) => {
            setReactionBar(!reactionBar);
          }}
        >
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {reactionBarOption.map((item) => {
              return (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "2px",
                  }}
                >
                  <ImageSwatch
                    style={{
                      width: 230,
                      height: 230,
                    }}
                    value={typeof item.key == "string" ? item.key : ""}
                    src={item.data.imageSrc ? item.data.imageSrc : ""}
                    aria-label={item.data.imageAlt}
                  />
                  <Label style={{ marginTop: "5px" }} weight="semibold">
                    {item.text}
                  </Label>
                </div>
              );
            })}
          </div>
        </SwatchPicker>
      </div>
      <Checkbox
        checked={selectedZubehoerKey == "" && !reactionBar}
        label={i18n.t<string>("withoutAccesories")}
        onChange={(ev, val) => {
          if (val.checked) {
            setSelectedAdapter(undefined);
            setSelectedZubehoerKey("");
            setReactionBar(false);
          }
        }}
      />
    </>
  );
}

export default Lsp3Connect;
